<template>
  <div class="busPlacement">
    <div class="busPlacement__header1">
      <div class="busPlacement__header1__filters">
        <adx-dropdown-search class="filter" @selected="selectRoute" labelButton="Route" :list="routeOptions" :selected-value="selectedRoute"/>
        <adx-dropdown-list class="filter" @selected="selectImage" v-if="imageOptions.length" :valueDisplay="selectedImage.value" :list="imageOptions" :labelButton="selectedImage.label?selectedImage.label:'Images'"/>
        <adx-dropdown-list class="filter" @selected="selectCondition" v-if="conditionOptions.length" :valueDisplay="selectedCondition.value" :list="conditionOptions" :labelButton="selectedCondition.label?selectedCondition.label:'Condition'"/>
        <adx-dropdown-list class="filter" @selected="selectStatus" v-if="statusOptions.length" :valueDisplay="selectedStatus.value" :list="statusOptions" :labelButton="selectedStatus.label?selectedStatus.label:'Status'"/>
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="busPlacement__header1__button"><button class="btn-large primary" @click="addNew">Add New Placement</button></div>
    </div>
    <div class="busPlacement__header2">
      <div class="busPlacement__header2__search">
        <i class="adx-ic_search"></i>
        <input v-model="searchBoxValue" type="text" placeholder="Search">
      </div>
      <div class="busPlacement__header2__sort">
        <p>Sort by :</p> 
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sortOptions"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="busPlacement__listing">
      <div class="tableWrapper">
      <table>
        <thead>
          <tr>
            <td class="col1">Placement</td>
            <td class="col2">Quantity</td>
            <td class="col2">Price (Rp)</td>
            <td class="col3">Status</td>
            <td class="col3"></td>
          </tr>
        </thead>
        <tbody v-if="!isLoading">
          <tr v-for="(placement, index) in placements" :key="index" class="content">
            <td class="col1">
              <div class="col1__placement-name">
                <div class="ellipsis"><span class="subhead type">{{placement.type}}</span></div>
                <div class="ellipsis"><span class="subhead name">{{placement.name}}</span></div>
              </div>
            </td>
            <td class="col2"><span class="subhead quantity">{{placement.quantity | formatNumber}}</span></td>
            <td class="col2"><span class="subhead ">{{placement.price | formatNumber}}</span></td>
            <td class="col2">
              <div class="status"> 
                <adx-label-status v-if="placement.image" :progress="imagesActive"/>
                <adx-label-status v-if="!placement.image" :progress="imagesInactive"/>
                <adx-label-status v-if="placement.active" :progress="activeActive"/>
                <adx-label-status v-if="!placement.active" :progress="activeInactive"/>
                <adx-label-status v-if="placement.public" :progress="publicActive"/>
                <adx-label-status v-if="!placement.public" :progress="publicInactive"/>
              </div>
            </td>
            <td class="col2">
               <menu-expansion class="placement-expansion" :lists="placement.delete? menuActionsNot : menuActions " @selected="selected($event,placement)"/>
            </td>
          </tr>
        </tbody> 
      </table>
      </div>
      <div v-if="isLoading" class="loadingState">
        <adx-loading />
      </div>
      <div v-if="isEmpty && !isLoading" class="emptyState">
        <adx-empty-selection :title="title" />
      </div>
      <div class="pagination" v-if="!isLoading && !isEmpty">
        <div class="total" >{{getDataRange}} of {{count}} Placements</div>
        <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
      </div>
    </div>
    <adx-modal hideClose="true" v-if="isShowModal" title="Delete Placement" type="small">
      <div slot="content" class="busPlacement__modal">
        <div class="busPlacement__modal__top">
          <span>Sure want to delete this placement?</span>
        </div>
        <div class="busPlacement__modal__bottom">
          <button class="btn-regular primary" @click="deletePlacement()">Yes<adx-loading-2 class="btn-loading" v-if="isLoadingMutation"/></button>
          <button class="btn-regular primary" @click="cancelDelete()">Cancel</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DropdownSort from '@/components/Form/SelectDropdown';
import tooltip from '@/components/Tooltip';
import EmptySelection from '@/components/NotFound/Selection';
import Loading from '@/components/Loading/Primary';
import LoadingWhite from '@/components/Loading/Secondary-white';
import Pagination from '@/components/Pagination';
import DropdownList from '@/components/Dropdown/ListDropdown';
import DropdownSearch from '@/components/Dropdown/SearchDropdown';
import LabelStatus from '@/components/StatusLabel';
import MenuExpansion from '@/components/MenuExpansion';
import Modal from '@/components/Modal';

import { 
  ALoadingPrimary, ALoadingSecondary, ALoadingSecondaryWhite, AEmptySelection, AModal,
  ASelectDropdown, APagination, AMenuExpansion 
} from "ui-kit-v1"

import * as validationLib from '@/lib/validation/'
import { mapGetters } from 'vuex'
import { parseErrorGql } from '@/lib/error'
import { restEdge } from '@/api/edgeUrls'
import api from '@/api'

const {
  helpers,
  validate
} = validationLib;

export default {
  name: 'adx-bus-route',
  components: {
    'adx-modal': Modal,
    'adx-dropdown-sort': DropdownSort,
    "tooltip": tooltip,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-loading-2': LoadingWhite,
    'adx-pagination': Pagination,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-search': DropdownSearch,
    'adx-label-status': LabelStatus,
    'menu-expansion': AMenuExpansion,
  },
  props: {

  },
  data() {
    return {
      title: "You dont have any placement here. lets create some !",
      isShowModal: false,
      selectedPlacementId: null,
      count: 0,
      countRoute: 0,
      isLoadingMain: false,
      isLoadingMutation: false,
      isEmpty: false,
      maxPage: 1,
      searchBoxValue: null,
      selectedPage: 1,
      selectedRoute: null,
      selectedRouteId: null,
      selectedSortValue: "last_added",
      active: {
        'label': 'ACTIVE',
        'value': 'active'
      },
      activeActive: {
          label: "Active",
          value: "active",
      },
      activeInactive: {
          label: "Active",
          value: "inactive",
      },
      imagesActive: {
          label: "Images",
          value: "active",
      },
      imagesInactive: {
          label: "Images",
          value: "inactive",
      },
      publicActive:  {
          label: "Public",
          value: "active",
      },
      publicInactive: {
          label: "Public",
          value: "inactive",
      },
      selectedCondition: {
        label: null,
        value: null
      },
      selectedImage: {
        label: null,
        value: null
      },  
      selectedStatus: {
        label: null,
        value: null
      },
      conditionOptions: [
        {
          id: 0,
          label: "All",
          value: null,
        },
        {
          id: 1,
          label: "Active",
          value: true,
        },
        {
          id:2,
          label: "Inactive",
          value: false,
        },
      ],
      imageOptions: [
        {
          id: 0,
          label: "All",
          value: null,
        },
        {
          id:1,
          label: "Featured Images",
          value: true,
        },
        {
          id:2,
          label: "Unset",
          value: false,
        },
      ],
      menuActions: [ 
        {
          'id': 0,
          'name': ' Edit Placement',
          'value': 'editbusplacement',
        },
        {
          'id': 1,
          'name': ' Duplicate Placement',
          'value': 'duplicatebusplacement'
        },
        {
          'id': 2,
          'name': 'Delete Placement',
          'value': 'deletebusplacement'
        }
      ],
      menuActionsNot: [
        {
          'id': 0,
          'name': ' Edit Placement',
          'value': 'editbusplacement',
        },
        {
          'id': 1,
          'name': ' Duplicate Placement',
          'value': 'duplicatebusplacement'
        },
        {
          'id': 2,
          'name': 'Delete Placement',
          'value': 'deletebusplacement',
          'disabled': 'You must deactivate and unpublish this item first, before delete.'
        }
      ],
      placements: [],
      routeOptions: [
        {
          id:1,
          title:"Airport Bus",
          locations:[]
        }
      ],
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added",
        },
        {
          label: "First Added",
          value: "first_added",
        },
      ],
      statusOptions: [
        {
          id:0,
          label: "All",
          value: null,
        },
        {
          id:1,
          label: "Public",
          value: true,
        },
        {
          id:2,
          label: "Draft",
          value: false,
        },
      ],

    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isLoading: function(){
      return this.isLoadingMain || this.isLoadingMutation
    },
    getDataRange: function(){
      let endPage = this.selectedPage*15;
      return this.count > 15? ((endPage < this.count)? endPage: endPage-15+(this.count%15)) : this.count
    },
    filtered: function() {
      let filtered = false
      if (this.selectedRoute || this.selectedCondition.label || this.selectedImage.label || this.selectedStatus.label){
        filtered = true
      }
      return filtered
    },
    getQueryParams() {
      let queryParams = {
        status: this.selectedStatus.value != null ? this.selectedStatus.value.toString() : undefined,
        search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
        route: this.selectedRoute != null ? this.selectedRouteId.toString() : undefined,
        image: this.selectedImage.value != null ? this.selectedImage.value.toString() : undefined,
        condition: this.selectedCondition.value != null ? this.selectedCondition.value.toString() : undefined,
        status: this.selectedStatus.value != null ? this.selectedStatus.value.toString() : undefined,
      }
      return queryParams
    }
  },
  apollo: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.selectedPage = 1;
        this.count = 0;
        this.getBusPlacements()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedPage = 1;
        this.selectedSortValue = newValue;
        this.count = 0;
        this.getBusPlacements()
      }
    },
    selectedRoute: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedPage = 1;
        this.selectedRoute = newValue;
        this.count = 0;
        this.getBusPlacements()
      }
    },
    selectedImage: function (newValue, oldValue) {
      if (newValue.value !== oldValue.value) {
        this.selectedPage = 1;
        this.selectedImage = newValue;
        this.count = 0;
        this.getBusPlacements()
      }
    },
    selectedStatus: function (newValue, oldValue) {
      if (newValue.value !== oldValue.value) {
        this.selectedPage = 1;
        this.selectedStatus = newValue;
        this.count = 0;
        this.getBusPlacements()
      }
    },
    selectedCondition: function (newValue, oldValue) {
      if (newValue.value !== oldValue.value) {
        this.selectedPage = 1;
        this.selectedCondition = newValue;
        this.count = 0;
        this.getBusPlacements()
      }
    },
    selectedPage: function(){
      this.count = 0;
      this.getBusPlacements()
    }
  },
  beforeCreate() {

  },
  created() {
    localStorage.setItem('apollo-token', this.token);
    const { from } = this.$route.query;
    if (from === 'add' || from === 'edit') {
      // this.$apollo.queries.busPlacementsPage.refetch()
      // this.count = 0
      // this.getBusPlacements()
    }
  },
  beforeMount() {

  },
  mounted() {
    this.count = 0;
    this.getRoutes();
    this.getBusPlacements()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    // async getRoutes(){
    //   const res = await this.$apollo.query({
    //     query: require('@/graphql/bus/query/singleSearchRoutes.gql'),
    //     loadingKey: 'loading',
    //     errorPolicy: 'all',
    //     fetchPolicy: 'network-only',
    //     variables:{
    //       input: undefined,
    //       admin:"true"
    //     },
    //   });
    //   if (res.data){
    //     if (res.errors){
    //       this.handleError(res.errors, 'route')
    //     } else {
    //       const {routes} = res.data;
    //       let result = [];
    //       routes.map(x => {
    //         result.push({'id': parseInt(x.id),'location': x.title || ''})
    //       });
    //       this.routeOptions[0].locations = result;
    //     }
    //   }
    // },
    async getRoutes(){
      const response = await api.get(restEdge.formGeneric, { needToken: true, useRestEdge: true });
      if(response.status == 200){
        const { data } = response;
        this.populateRoutes(data.routes);
      }
    },
    async populateRoutes(listRoutes){
      if(listRoutes){
        let result = []
        await listRoutes.map( route => {
          result.push({'id': parseInt(route.id),'location': route.title || ''})
        });
        this.routeOptions[0].locations = result;
      }
    },
    // async getBusPlacements(){
    //   this.isLoadingMain = true;
    //   const res = await this.$apollo.query({
    //     query: require('@/graphql/bus/query/placementPage.gql'),
    //     loadingKey: 'loading',
    //     errorPolicy: 'all',
    //     fetchPolicy: 'network-only',
    //     variables:{
    //       page: this.selectedPage.toString() || "1",
    //       sort: this.selectedSortValue.toString(),
    //       title: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
    //       route: this.selectedRoute != null ? this.selectedRoute.toString() : undefined,
    //       photo: this.selectedImage.value != null ? this.selectedImage.value.toString() : undefined,
    //       condition: this.selectedCondition.value != null ? this.selectedCondition.value.toString() : undefined,
    //       status: this.selectedStatus.value != null ? this.selectedStatus.value.toString() : undefined,
    //       admin: "true"
    //     },
    //   });
    //   if (res.data){
    //     this.isEmpty = false;
    //     const { busPlacementsPage } = res.data;
    //     if (res.errors){
    //       this.handleError(res.errors, 'placement')
    //     } else {
    //       let result = [];
    //       await busPlacementsPage.busPlacements.map(x => {
    //         let featuredImage = x.contents.filter(y => {
    //           return y.is_featured
    //         });
    //         result.push({
    //             'id': parseInt(x.id),
    //             'name': x.route.title || '',
    //             'type' : x.generic ? x.generic.title || '' : '',
    //             'route': x.route.title || '',
    //             'quantity': x.generic? parseInt(x.generic.quantity) : 0,
    //             'price': x.generic? parseInt(x.generic.price) :0,
    //             'image': featuredImage.length>=1,
    //             'active': x.generic.isActive,
    //             'public': x.generic.isPublic,
    //             'delete': x.generic.isActive || x.generic.isPublic,
    //           })
    //       });
    //       this.placements = await result;
    //       this.maxPage = busPlacementsPage.meta.maxPage;
    //       this.count = busPlacementsPage.meta.count;
    //       if (this.placements.length === 0) this.isEmpty = true;
    //       this.isLoadingMain=false
    //     }

    //   }

    // },
    async getBusPlacements(){
      this.isLoadingMain = true;
      const response = await api.get(restEdge.busPlacement, { needToken: true, useRestEdge: true, params:{page:this.selectedPage, ...this.getQueryParams, sort: this.selectedSortValue}});
      if(response.status == 200){
        const {data} = response
        let tmpPlacement = []
        await data.results.map( placement => {
          tmpPlacement.push({
            'id': placement.id,
            'name': placement.route.title || '',
            'type' : placement.generic ? placement.generic.title || '' : '',
            'route': placement.route.title || '',
            'quantity': placement.generic? placement.generic.quantity : 0,
            'price': placement.generic? placement.generic.price :0,
            'image': placement.contents.filter(content => content.is_featured == true).length > 0,
            'active': placement.generic.isActive,
            'public': placement.generic.isPublic,
            'delete': placement.generic.isActive || placement.generic.isPublic,
          })
        });
        this.placements = await tmpPlacement;
        this.maxPage = await data.maxPage;
        this.count = await data.count;
        this.isEmpty = this.placements.length === 0
        this.isLoadingMain = false;
      } else {
        console.log(`error`)
      }
    },
    selected(index, item){
      if(index.value ===  'editbusplacement'){
        this.$router.push({name: 'editbusplacement',  params: {  id: item.id }})
      } else if(index.value ===  'duplicatebusplacement'){
        this.duplicatePlacement(item.id)
      } else if(index.value ===  'deletebusplacement'){
        this.confirmDelete(item.id)
      }
    },
    addNew() {
      this.$router.push({name: 'addnewbusplacement'})
    },
    showNotify(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors);
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code;
          if (parsedError.code === 204) code = 404;
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'placement':
              this.count++;
              if (this.count<3) {
                await this.getBusPlacements()
              } else {
                this.isLoadingMain = false;
                this.isEmpty=true;
                this.showNotify()
              }
              break;
            case 'route':
              this.countRoute++;
              if (this.countRoute<3){
                await this.getRoutes()
              } else {
                // TODO: Add statement to execute if main condition is not fullfilled
              }
          }
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async duplicatePlacement(id) {
      this.isLoadingMutation = true;
      const response = await api.post(restEdge.duplicatePlacement(id), {}, { needToken: true, useRestEdge: true,});
      
      if (response.status == 200) {
        this.getBusPlacements();
        this.isLoadingMutation = false;
        this.$notify({
          group: 'saved',
          title: 'Success',
          text: `Data successfully duplicated!`,
          type: 'success'
        });
      } else {
        this.isLoadingMutation = false
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Data failed to duplicate!`,
          type: 'danger'
        });
      }
    },
    async deletePlacement() {
      this.isLoadingMutation = true;
      const response = await api.destroy(restEdge.deletePlacement(this.selectedPlacementId), { needToken: true, useRestEdge: true})
      if(response.status == 200){
        this.toggleModal();
        this.getBusPlacements();
        this.isLoadingMutation = false;
        this.$notify({
          group: 'saved',
          title: 'Success',
          text: `Data successfully deleted!`,
          type: 'success'
        });
      } else {
        this.toggleModal();
        this.getBusPlacements();
        this.isLoadingMutation = false;
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Data failed to delete!`,
          type: 'danger'
        });
      }
    },
    confirmDelete(id){
      this.selectedPlacementId = id;
      this.toggleModal()
    },
    cancelDelete(){
      this.selectedPlacementId = null;
      this.toggleModal()

    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    showMore() {
      
    },
    selectPage(item) {
      this.selectedPage = item
    },
    selectRoute(item) {
      this.selectedRouteId = item.id
      this.selectedRoute = item.location
    },
    selectImage(item){
      this.selectedImage = item
    },
    selectCondition(item){
      this.selectedCondition = item
    },
    selectStatus(item){
      this.selectedStatus = item
    },
    resetFilter() {
      let condition = {
          id: 0,
          label: null,
          value: null,
        }
      let image = {
          id:0,
          label: null,
          value: null,
        }
      let status = {
          id:0,
          label: null,
          value: null,
        }
      this.selectedRoute = null
      this.selectCondition(condition)
      this.selectImage(image)
      this.selectStatus(status)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';

.dropdown__menu{
    min-width: max-content;
}
</style>

<style lang="scss">
  .placement-expansion {
    .tooltiptext {
      right: auto;
      min-width: 165px;
    }
  }
</style>